import { useDataBoxSelector } from 'app/common/data-box-store'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import {
  detailsGroupFilterSelection,
  viewTypeFilter,
  viewTypeFilterSelection,
} from 'app/dataProviders/filter-items'

type Props = { id: string; pending: boolean }

export const ViewTypeFilter = ({ id, pending }: Props) => {
  const group = useDataBoxSelector(
    detailsGroupFilterSelection,
    () => detailsGroupFilterSelection.data,
  )
  if (group === 'by_klasses_and_orders') return null

  return (
    <PlainItemsSelectorBox
      id={id}
      label="Вид отображения"
      header="Выбор вида отображения"
      dataBoxData={viewTypeFilter}
      dataBoxSelection={viewTypeFilterSelection}
      defaultSelection={['sum']}
      disabled={pending}
    />
  )
}
